<template>
  <div class="retrieve-index">
      <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'RetrieveIndex'
}
</script>

<style scoped>
.retrieve-index {
  width: 100%;
  height: 100%;
  padding-bottom: 70px;
}
</style>



// WEBPACK FOOTER //
// src/views/retrieve/index.vue